import defineThemeMiddleware from '#shared/util/defineThemeMiddleware.js';

/**
 * Set localization strings to Vuex store
 */
export default defineThemeMiddleware(({ store, response }) => {
	store.commit('SET_LOCALIZATION', response.locals.regionConfig.localization);
}, (context) => context.isServerProcess);
